import { toast } from 'react-toastify'
import {
  useFetchProfile,
  useUpdateProfile,
  useUploadToAWS,
} from '../../hooks/api'
import * as Yup from 'yup'
import { useEffect, useState } from 'react'
import { jwtDecode, JwtPayload } from 'jwt-decode'
import Cookies from 'js-cookie'

interface IUser{admin:{id:string}}
export const useProfileLogic = () => {

  const accessToken= Cookies.get('access_token') || ""
const userProfileData= sessionStorage.getItem("user")


const userProfile=!userProfileData?null:JSON.parse(userProfileData)

  const user: IUser = {
admin:{
  id:userProfile?.id }
  }
  console.log({userProfileData,userProfile, user})
  const fetchProfile = useFetchProfile(user?.admin?.id)
  const updateProfile = useUpdateProfile()
  const profileValidationSchema = Yup.object({
    confirm_password: Yup.string()
      .required('Enter Confirm Password')
      .test(
        'confirm_password',
        'New Password is not Same as Confirm Password',
        (val, ctx) => {
          if (val === ctx.parent.password) {
            return true
          } else {
            return false
          }
        },
      ),
  })

  const uploadToAWS = useUploadToAWS()

  const [profile, setProfile] = useState<UpdateProfilePayload>({
    email: '',
    name: '',
    profile_picture: '',
    role_id: '',
    user_id: user?.admin?.id,
  })

  useEffect(() => {
    if (fetchProfile.data) {
      let profileData = fetchProfile.data.data

      setProfile(prev => ({
        ...prev,
        email: profileData.admin.email,
        name: profileData.admin.name,
        profile_picture: profileData.admin?.profile_picture || '',
        role_id: profileData?.role?.id,
     
      }))
    }
  }, [fetchProfile.data])
  const uploadAvatar = (profile: UpdateProfilePayload, file: any) => {
    const formData = new FormData()
    formData.append('file', file)
    const loading = toast.loading(`uploading file`)
    uploadToAWS.mutate(
      { file },
      {
        onSuccess: (response) => {
          console.log({ response })
          setProfile((prev) => ({ ...prev, profile_picture: response?.url }))
          updateProfile.mutate(
            { ...profile, profile_picture: response?.url },
            {
              onSuccess: () => {
                toast.success(``)
              },
            },
          )
        },
        onSettled: () => {
          toast.dismiss(loading)
        },
      },
    )
  }
  return {
    fetchProfile,
    updateProfile,
    profileValidationSchema,
    uploadAvatar,
    profile,
  }
}
export default useProfileLogic
